import { INDIA_COUNTRY_CODE } from '@packages/domain/constants/countries';
import { useQuery } from '@tanstack/react-query';
import { fetchAuthorizedDealer } from 'actions/entities/orders/india/fetchAuthorizedDealer';
import { fetchOrderExpirationDate } from 'actions/entities/orders/india/fetchOrderExpirationDate';
import { FF_CALCULATE_FOR_RBI } from 'constants/features';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags';
import { useSelector } from 'react-redux';
import { getSenderCountry } from 'selectors/entities/order/order';
import { useDispatch } from 'store/configureStore';

export const useAdditionalInfo = () => {
  const dispatch = useDispatch();
  const senderCountry = useSelector(getSenderCountry);
  const isPayingFromIndia = senderCountry.toUpperCase() === INDIA_COUNTRY_CODE;

  const { data: featureFlags } = usePeertransferFlags([FF_CALCULATE_FOR_RBI]);
  const isRbiFeatureEnabled = featureFlags?.[FF_CALCULATE_FOR_RBI] ?? false;

  const enabled = isPayingFromIndia && isRbiFeatureEnabled;

  const { data: authorizedDealer = null } = useQuery({
    queryKey: ['india', 'authorizedDealer'],
    queryFn: () => dispatch(fetchAuthorizedDealer()),
    enabled,
  });

  const { data: orderExpirationDate = '' } = useQuery({
    queryKey: ['india', 'orderExpirationDate'],
    queryFn: () => dispatch(fetchOrderExpirationDate()),
    enabled,
  });

  return { authorizedDealer, orderExpirationDate };
};
